import * as paymentOption from './paymentOption';
import * as billingAddress from './billingAddress';
import * as creditCard from './creditCard';
export default { paymentOption: paymentOption, billingAddress: billingAddress, creditCard: creditCard };
